import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { MagnifyingGlass as Search } from "@phosphor-icons/react";

interface FilteredSearchLink {
  title: string;
  description: string;
  url: string;
}

interface BlogFilteredSearchLinksProps {
  links?: FilteredSearchLink[];
}

const defaultLinks: FilteredSearchLink[] = [
  {
    title: "SUV 7 locuri sub 15.000 EUR",
    description: "Găsește SUV-uri spațioase perfecte pentru familie",
    url: "/vehicles?type=suv&priceMax=15000&seats=7"
  },
  {
    title: "Mașini diesel sub 10.000 EUR",
    description: "Modele diesel economice și fiabile",
    url: "/vehicles?fuelType=diesel&priceMax=10000"
  },
  {
    title: "Anunțuri auto în București",
    description: "Anunțuri de la dealeri și vânzători privați",
    url: "/vehicles?location=Bucure%C8%99ti"
  }
];

export function BlogFilteredSearchLinks({ links = defaultLinks }: BlogFilteredSearchLinksProps) {
  return (
    <Card className="bg-gradient-to-br from-accent/10 via-accent/5 to-background border-accent/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-xl font-playfair">
          <Search className="text-accent" size={24} />
          Caută mașini după aceste criterii
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground mb-4">
          Bazat pe informațiile din acest articol, iată căutări relevante pentru tine:
        </p>
        {links.map((link, index) => (
          <Link key={index} to={link.url} className="block">
            <Button 
              variant="outline" 
              className="w-full justify-start text-left h-auto py-4 px-5 hover:bg-accent/10 hover:border-accent transition-all"
            >
              <div className="flex-1">
                <div className="font-semibold mb-1">{link.title}</div>
                <div className="text-xs text-muted-foreground font-normal">
                  {link.description}
                </div>
              </div>
              <Search size={18} className="ml-3 flex-shrink-0 text-accent" />
            </Button>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
